declare global {
    interface Window {
        iFrameResizer:any;
    }
}

const PRIVACY_SETTINGS_MODAL_CONTENT = '.js-privacy-content';
const PRIVACY_SETTINGS_MODAL_TRIGGER = '.js-privacy-modal-trigger';
const PRIVACY_SETTINGS_MODAL = '.js-privacy-modal';

export async function showPrivacySettingsModal(): Promise<void> {
    const privacyModalTrigger = document.querySelectorAll(PRIVACY_SETTINGS_MODAL_TRIGGER);
    const privacyModal = document.querySelector(PRIVACY_SETTINGS_MODAL);
    const privacyContent = document.querySelector<HTMLElement>(PRIVACY_SETTINGS_MODAL_CONTENT);

    if( !privacyModalTrigger || !privacyContent ) {
        return;
    }

    privacyModalTrigger.forEach(privacyTrigger => {
        privacyTrigger.addEventListener('click', () => {
            const modalData = privacyTrigger.getAttribute('data-modal-content')

            if(!modalData || !privacyModal) {
                return;
            }

            getPrivacyData(modalData)
                .then(res => {
                    privacyContent.innerHTML = res;
                    privacyModal.classList.add('is-visible');

                    includeCookieSaveFunction();
                });
        })
    });
}

async function includeCookieSaveFunction(): Promise<void> {
    const { setCookies } = await import('../cookieMessage');

    setCookies();
}

async function getPrivacyData (url: string): Promise<string> {
    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/html'
        },
    });

    if (!res.ok) {
        throw new Error(`request failed: got response code ${res.status}`);
    }

    return res.text();
}
